<template>
  <base-dialog width="485px" class="update-owner-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>
      更换负责人
    </template>
    <el-form>
      <el-form-item label="设置新负责人" label-width="100px">
        <user-selector v-model="ownerId" :app-id="appId"></user-selector>
      </el-form-item>
      <el-form-item label="将原负责人" label-width="100px">
        <div>
          <base-button :type="partFlag ? 'primary' : 'default'" @click="partFlag = true">
            转为参与者
          </base-button>
          <base-button :type="partFlag ? 'default' : 'primary'" @click="partFlag = false">
            移出团队
          </base-button>
        </div>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserSelector from "@/components/FormControl/UserSelector"
export default {
  name: "UpdateOwnerDialog",
  components: { BaseButton, BaseDialog, UserSelector },
  props: {
    appId: String
  },
  data() {
    return {
      visible: false,
      ownerId: [],
      partFlag: true // 当重新设置负责人时,是将老负责人转为参与人,还是移出团队
    }
  },
  methods: {
    open() {
      this.visible = true
      this.ownerId = []
      this.partFlag = true
    },
    submit() {
      if (this.ownerId.length != 1) {
        this.$message.error("请选择负责人")
        return
      }
      this.$emit("select", { ownerId: this.ownerId[0], partFlag: this.partFlag })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.update-owner-dialog {
  .el-form {
    margin-top: 18px;
    ::v-deep {
      .el-form-item {
        .el-form-item__label {
          text-align: left;
        }
        .el-form-item__content {
          display: flex;
          .el-select {
            flex: 1;
          }
          > span {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
